import { WebcamSourceConfigProvider } from '@/contexts/WebcamSourceConfigContext';
import { createFileRoute } from '@tanstack/react-router'
import { createAuthGuard } from '@/lib/authGuard'

export const Route = createFileRoute('/places/screen-capture')({
  beforeLoad: createAuthGuard(),
  component: RouteComponent,
})

//TODO: Setup the capture-a-screen stuff here to monitor a window or screen. (not webcam)
function RouteComponent() {
  return (<WebcamSourceConfigProvider>
        <div>Hello "/places/screen-capture"!</div>
    </WebcamSourceConfigProvider>);
}
